const uberV2 = {
  voucherDueDateTitle: 'Vencimiento',
};

module.exports = uberV2;
